import TableContainer from "components/Common/TableContainer"
import React, { useMemo } from "react"
import { Badge, Card, CardBody, UncontrolledTooltip } from "reactstrap"
import { formatBDT } from "utils/formatPrice"

export default function QuotationsTab({ setQuotationPage }) {
  const isLoading = false
  const data = {
    data: [
      {
        id: 1,
        number: "QT-001",
        date: "2025-01-10",
        amount: 145000,
        customer: "Robert Brown",
        status: "Accepted",
      },
      {
        id: 2,
        number: "QT-002",
        date: "2025-01-12",
        amount: 148000,
        customer: "Emily Davis",
        status: "Pending",
      },
    ],
    pagination: {
      current_page: 1,
      from: 1,
      last_page: 1,
      to: 2,
      total: 2,
    },
  }
  // Quotation Table Columns
  const quotationColumns = useMemo(
    () => [
      {
        header: "Quotation No",
        accessorKey: "number",
      },
      {
        header: "Date",
        accessorKey: "date",
      },
      {
        header: "Customer",
        accessorKey: "customer",
      },
      {
        header: "Amount",
        accessorKey: "amount",
        cell: ({ row }) => formatBDT(row.original.amount),
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: ({ row }) => (
          <Badge
            color={row.original.status === "Accepted" ? "success" : "warning"}
          >
            {row.original.status}
          </Badge>
        ),
      },
      {
        header: "Action",
        cell: ({ row }) => (
          <ul className="list-unstyled hstack gap-1 mb-0">
            <li>
              <button
                type="button"
                className="btn btn-sm btn-soft-info"
                id={`view-qt-tooltip-${row.original.id}`}
              >
                <i className="mdi mdi-eye-outline" />
                <UncontrolledTooltip
                  placement="top"
                  target={`view-qt-tooltip-${row.original.id}`}
                >
                  View
                </UncontrolledTooltip>
              </button>
            </li>
            <li>
              <button
                type="button"
                className="btn btn-sm btn-soft-warning"
                id={`edit-qt-tooltip-${row.original.id}`}
              >
                <i className="mdi mdi-pencil-outline" />
                <UncontrolledTooltip
                  placement="top"
                  target={`edit-qt-tooltip-${row.original.id}`}
                >
                  Edit
                </UncontrolledTooltip>
              </button>
            </li>
            <li>
              <button
                type="button"
                className="btn btn-sm btn-soft-primary"
                id={`download-qt-tooltip-${row.original.id}`}
              >
                <i className="mdi mdi-download" />
                <UncontrolledTooltip
                  placement="top"
                  target={`download-qt-tooltip-${row.original.id}`}
                >
                  Download
                </UncontrolledTooltip>
              </button>
            </li>
          </ul>
        ),
      },
    ],
    []
  )
  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0 fw-semibold">Quotations</h5>
          <Badge color="primary" pill className="px-3 py-2">
            {data.pagination.total} records
          </Badge>
        </div>

        <TableContainer
          columns={quotationColumns}
          data={data.data}
          isPagination={true}
          paginationInfo={data.pagination}
          onPageChange={setQuotationPage}
          loading={isLoading}
        />
      </CardBody>
    </Card>
  )
}
